<!-- Muestra la hora actual obtenida desde la BD mediante un servicio -->
<template>
  <div class="noselect black--text ml-4" width="300">
    <v-tooltip color="secondary" bottom>
      <template v-slot:activator="{ on }">
        <v-layout v-on="on" align-center>
          <v-icon v-if="horaActual !== null" color="secondary">watch_later</v-icon>&nbsp;&nbsp;&nbsp;
          <span class="subheading" v-if="horaActual !== null">
            [<span class="mobile-disapear" ref="date"></span>
            <span ref="time"></span> {{ periodo }}]
          </span>
          <span class="subheading" v-else>[No se pudo obtener la hora del servidor]</span>
        </v-layout>
      </template>
      <span>
        La hora en Bolivia (GMT-4)
      </span>
    </v-tooltip>
    <div v-if="tipo_usuario !== 'usuario_externo'">
      <v-tooltip color="success" bottom>
        <template v-slot:activator="{ on }">
          <v-layout v-on="on" align-center>
            <v-icon v-if="estadoFirmador" color="success">check_circle</v-icon>&nbsp;
            <v-icon v-if="!estadoFirmador" color="error">error</v-icon>&nbsp;
            <span class="subheading" v-if="estadoFirmador">
              [<span> Firma Digital Disponible </span>]
            </span>
            <span class="subheading" v-else>[La Firma Digital no está disponible en este momento]</span>
          </v-layout>
        </template>
        <span>
          Servicio de Firma Digital
        </span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
const moment = require('moment');
export default {
  name: 'CardCurrentTime',
  data: () => ({
    horaActual: null,
    secondsInterval: null,
    refreshInterval: null,
    estadoFirmador: null,
    tipo_usuario: '',
    periodo: null
  }),
  mounted () {
    this.obtenerFechaHoraActual();
    let token = this.$util.parseJwt(this.$storage.get('token'));
    this.tipo_usuario = token.tipo;
  },
  beforeDestroy () {
    clearInterval(this.secondsInterval);
    clearInterval(this.refreshInterval);
  },
  methods: {
    obtenerFechaHoraActual () {
      try {
        this.$service.get('fecha_hora_actual', {}).then(response => {
          this.horaActual = moment(response.now.replace(/[ PM]|[ AM]/g, ''));
          this.periodo = response.now.split(' ')[1];
          // Se añaden 2 segundos adicionales al tiempo obtenido por el servicio
          this.horaActual = this.horaActual.add(2, 'seconds');
          // Se inicia el intervalo que incrementa segundos (cada segundo)
          this.secondsInterval = setInterval(() => {
            if (this.horaActual && this.$refs.date && this.$refs.time) {
              this.horaActual = this.horaActual.add(1, 'seconds');
              this.$refs.date.innerHTML = `${this.horaActual.format('DD/MM/YYYY')} hrs.`;
              this.$refs.time.innerHTML = `${this.horaActual.format('hh:mm:ss')}`;
            }
          }, 1000);
          // Se inicia el intervalo que actualiza la hora con el servidor (cada 15 segundos)
          this.refreshInterval = setInterval(() => {
            this.$service.get('fecha_hora_actual', {}).then(response => {
              const timeNow = response.now.replace(/[ PM]|[ AM]/g, '');
              this.periodo = response.now.split(' ')[1];
              this.horaActual = moment(timeNow);
              this.estadoFirmador = response.esValido === 'true';
            });
          }, 60000);
          this.estadoFirmador = response.esValido === 'true';
        }).catch(error => {
          console.log(error);
        });
      } catch (error) {
        console.error(error);
        this.horaActual = null;
      }
    }
  }
};
</script>
<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>



// WEBPACK FOOTER //
// src/common/util/CardCurrentTime.vue